function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("polygon", {
  points: "59,7 56,7 56,4 3,4 3,7 0,7 0,1 59,1  "
})))), React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("path", {
  d: "M30.4,39.7c-6.9,0-12-10-12-16.5c0-6.7,5.4-12.2,12-12.2s12,5.5,12,12.2C42.5,29.7,37.3,39.7,30.4,39.7z M30.4,13.9 c-5,0-9,4.1-9,9.2c0,5.1,4.2,13.5,9,13.5s9-8.4,9-13.5C39.5,18.1,35.4,13.9,30.4,13.9z"
})))), React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("polygon", {
  points: "9,46 6,46 6,41.3 22.7,32.9 24.1,35.6 9,43.1  "
})))), React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("polygon", {
  points: "54,46 51,46 51,43.3 36.5,36 37.9,33.4 54,41.4  "
})))), React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("path", {
  d: "M1,38.8v-3c3.9,0,7.8-6.9,7.8-11.8c0-4.4-3.5-8-7.8-8v-3c6,0,10.8,4.9,10.8,11C11.8,29.9,7.2,38.8,1,38.8z"
})))), React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("rect", {
  x: 5,
  y: 35.4,
  transform: "matrix(0.8702 0.4927 -0.4927 0.8702 19.4441 -6.129055e-02)",
  width: 9.6,
  height: 3
}))))), React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("path", {
  d: "M59.2,38.8c-6.2,0-10.8-9-10.8-14.8c0-6.1,4.8-11,10.8-11v3c-4.3,0-7.8,3.6-7.8,8c0,4.9,3.9,11.8,7.8,11.8V38.8z"
})))), React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("rect", {
  x: 48.9,
  y: 32.1,
  transform: "matrix(0.4928 0.8702 -0.8702 0.4928 57.6527 -25.1642)",
  width: 3,
  height: 9.6
})))))), React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("polygon", {
  points: "59,60 0,60 0,49 3,49 3,57 56,57 56,49 59,49  "
})))));

var SvgAudience = function SvgAudience(props) {
  return React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 60 60",
    style: {
      enableBackground: "new 0 0 60 60"
    },
    xmlSpace: "preserve"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/audience.8527395c.svg";
export { SvgAudience as ReactComponent };